import { BUSCAR_EMPRESA } from '../../actions/types'

const initialState = undefined
const estadoInicial = {
  empresa: {
    tipoControleEmissaoBPe: ''
  }
}

export default function reducerEmpresasGestao (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_EMPRESA: {
      if (action.payload.data) {
        const empresa = action.payload.data;
        return {
          ...state,
          empresa
        }
      }
      return state
    }

    default: {
      return state
    }
  }
}
